import Vue from "vue";
import App from "./App";
import Mint from "mint-ui";
import Meta from "vue-meta";
import animated from "animate.css"; // animate动画库安装
import VueWechatTitle from "vue-wechat-title"; // 每个子页面添加标题

import "../../assets/css/reset.min.css"; // 导入初始css
import "lib-flexible/flexible";
import "mint-ui/lib/style.css";

import store from "../../store/active";
import router from "../../router/thirdAnniversary";

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.use(Mint);
Vue.use(VueWechatTitle);
Vue.use(animated);
Vue.use(Meta);

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/pages/thirdAnniversary/thirdAnniversary.js